import { ElementType } from 'react'
import { CheckCircleIcon, CircleIcon, XCircleFillIcon } from '@systemeio/icons'
import { CourseLectureAssignmentStatusEnum } from '../types/course-menu-interface'

export const STATUS_ICONS = {
  [CourseLectureAssignmentStatusEnum.NotSubmitted]: CircleIcon,
  [CourseLectureAssignmentStatusEnum.Pending]: CircleIcon,
  [CourseLectureAssignmentStatusEnum.Approved]: CheckCircleIcon,
  [CourseLectureAssignmentStatusEnum.Rejected]: XCircleFillIcon,
} as const satisfies Record<CourseLectureAssignmentStatusEnum, ElementType>
